import React from "react";
import { RaisedButton } from "material-ui";
import BallotingRecord from "./balloting-record.jsx";
import connectToStores from "alt-utils/lib/connectToStores";
import EventStore from "../../stores/EventStore";
import EventActions from "../../actions/EventActions";
import TicketStore from "../../stores/TicketStore";
import TicketActions from "../../actions/TicketActions";

@connectToStores
class VoteButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  static getStores() {
    return [EventStore, TicketStore];
  }

  static getPropsFromStores() {
    return {
      getEventById: EventStore.getEventById,
      getTicketsByEventId: TicketStore.getTicketsByEventId,
    };
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    appSettings: React.PropTypes.object,
    isLarge: React.PropTypes.bool
  };

  componentWillMount() {
    EventActions.fetchAll.defer();
    TicketActions.fetchAll.defer();
  }

  render() {
  
    const { 
      online_balloting_for_physical_events_enabled,
      online_balloting_voting_enabled
    } = this.context.appSettings;

    let { eventId, style, label } = this.props;

    let event = this.props.getEventById(eventId);
    let tickets = this.props.getTicketsByEventId(eventId);

    const showVote = 
      online_balloting_for_physical_events_enabled && 
      event && 
      !event.is_virtual && 
      event.films &&
      event.films.length &&
      event.films.length > 0 &&
      tickets.length &&
      tickets.length > 0;
    const voteClosed = online_balloting_voting_enabled ? false : true;
    const voteDisabled = tickets.every(t => t.ballot_recorded_at);

    let button = (
      <RaisedButton
        className="eventive__vote-button__button"
        disabled={voteDisabled || voteClosed}
        label={
          voteDisabled
            ? "Already voted"
            : voteClosed
            ? "Voting closed"
            : label || "Vote"
        }
        labelPosition="before"
        primary={true}
        onClick={() => this.setState({ open: true })}
      >
      </RaisedButton>
    );

    return (
      <div
        className="eventive__vote-button__container"
        data-button-mode="pass"
      >
        {this.state.open ? (
          <BallotingRecord
            eventId={eventId}
            tickets={tickets.map(t => {
              return t.id;
            })}
            onClose={() => this.setState({ open: false }, function() { TicketActions.fetchAll.defer(); })}
          />
        ) : null}
        {showVote ? button : null}
      </div>
    );
  }
}

export default VoteButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/vote-button.jsx